import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './PageHeader.less';

export class PageHeader extends PureComponent {
    static propTypes = {
        customHeader: PropTypes.node
    };

    render() {
        const { customHeader } = this.props;

        return (
            <header className="PageHeader">
                {customHeader || ''}
            </header>
        );
    }
}

export default PageHeader;
